type RequestIdentity = {requestNumber?: string; createdByName?: string}

export function formatTopicRequestLabel(request?: RequestIdentity | null) {
  const number = String(request?.requestNumber || '').trim()
  return /^[1-9]\d*$/.test(number) ? 'Solicitação Nº ' + number : 'Solicitação'
}

export function formatTopicRequestAuthor(request?: RequestIdentity | null) {
  return String(request?.createdByName || '').trim() || 'Usuário não identificado'
}
